import { CallNumber } from "@ionic-native/call-number";
import { CompleteTripModel } from "../../../models/home/CompleteTrip.model";
import { GetShipment } from "../../../models/home/GetShipment.model";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import {
  CALL_US_NUMBER,
  EXECUTIONSTATUS,
  DB_GPS_ACTIVATED_SHIPMENT,
  MODULES,
  MOBILE_PAYMENT_LINK,
  EGPSTrackingStatus,
} from "../../../utils/constants";
import { getValueFromHistoryState } from "./ShipmentStop.util";
import { StopInformation } from "../../../schemas/Exicution/exicution.schema";
import { UpdateStopModel } from "../../../models/home/updateStop.model";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { GPSWrapper, IONICWrapper } from "../../../utils/common";
import { isPlatform } from "@ionic/react";
import { isHardStop } from "../../../utils/formatData";
import { dayjs } from "../../../utils/Date/DateUtil";
import { removePropertyFromObject } from "../../../web/utils/BasicLogical.Util";
import { IMember, ISHIPMENT_INVLOVED_PARTY } from "../../../utils/AllInterface";
import { IUserDetails } from "../../../schemas/user";

export const refreshShipmentsLoads = (shipment: any, props: any) => {
  if (shipment.executionStatus === EXECUTIONSTATUS.IN_TRANSIT) {
    removeLoadsFromDriverToIntransit(shipment, props);
  } else if (shipment.executionStatus === EXECUTIONSTATUS.DELIVERED) {
    removeLoadsFromIntransitToDelivered(shipment, props);
  }
};

const removeLoadsFromDriverToIntransit = (shipment: any, props: any) => {
  const shipmentId: string = shipment && shipment.shipmentId;
  if (!shipmentId) {
    return;
  }
  const driverAssignedload: boolean =
    props.moduleName === MODULES.DRIVER_ASSIGNED_MODULE;
  const loads = driverAssignedload ? props.driverLoads : props.carrierLoads;
  const LoadList: any[] =
    loads && loads.filter((item: any) => item.shipmentId !== shipmentId);
  const isExists =
    loads &&
    loads.filter((item: any) => item.shipmentId === shipmentId).length > 0;
  if (isExists) {
    let inTransitLoads: any[] = props.inTransitLoads || [];
    if (shipment) {
      inTransitLoads = inTransitLoads.concat({ ...shipment });
    }
    driverAssignedload
      ? props.refreshDriverLoads(LoadList)
      : props.refreshCarrierLoads(LoadList);
    props.refreshInTransitLoad(inTransitLoads);
  }
};

const removeLoadsFromIntransitToDelivered = (shipment: any, props: any) => {
  const shipmentId: string = shipment && shipment.shipmentId;
  if (!shipmentId) {
    return;
  }
  const inTransitLoads: any[] = props.inTransitLoads.filter(
    (item: any) => item.shipmentId !== shipmentId
  );
  const isExists =
    props.inTransitLoads.filter((item: any) => item.shipmentId === shipmentId)
      .length > 0;
  if (isExists) {
    let recentDelivered: any[] = props.recentDelivered || [];
    if (shipment) {
      recentDelivered = recentDelivered.concat({ ...shipment });
    }
    props.refreshRecentDelivered(recentDelivered);
    props.refreshInTransitLoad(inTransitLoads);
  }
};
export const getLoadDetails = (shipmentToStartTrip: any): any => {
  return shipmentToStartTrip || {};
};

export const getConfirmStartStatus = (startTripShipmentStatusMessage: any) => {
  const response = startTripShipmentStatusMessage || {};
  if(isHardStop(response.status)){
    return true 
  } 
  return response.status === false;
};

export const getConfirmStartMessage = (startTripShipmentStatusMessage: any) => {
  const response = startTripShipmentStatusMessage || {};
  return response.message;
};

export const completeTripClick = (loadDetails: any, props: any) => {
  if (!props.networkStatus) {
    props.showAlert();
    return;
  }
  completeTripRequest(loadDetails.sourceTMS, loadDetails.shipmentId, props);
};

export const paymentStatusClick = (loadDetails: any,userDetails:any) => {
  const paymentStatusLink  = IONICWrapper.details.keys && IONICWrapper.details.keys.configuration && IONICWrapper.details.keys.configuration.mobilePaymentLink || MOBILE_PAYMENT_LINK;
  window && window.open(paymentStatusLink,'_blank');
  const shipmentId = (loadDetails && loadDetails.shipmentId) || "";
  const carrierId = (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId) || "";
  const roles =  (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.userApplicationDetails[0] && userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles) || [];
  logEvent(EVENT.UE_PAYMENT_STATUS_REDIRECT, {
    screen:SCREEN.DELIVERED_SHIPMENT_DETAILS,
    carrierId,
    shipmentId,
    roles
  });
}

const completeTripRequest = (
  sourceSystem: string,
  shipmentId: string,
  props: any
) => {
  const { userDetails = {} } = props;
  const objModel: CompleteTripModel = new CompleteTripModel();
  props.shipmentCompleteTrip(
    objModel.completeTrip({
      carrierId: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      shipmentId,
      sourceSystem,
      userId:userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn,
    }),
    shipmentId
  );
  setScreenName("screen_shipment_update");
  // Analytics implementation
  logEvent(EVENT.UE_COMPLETE_TRIP, {
    screen: SCREEN.SHIPMENT_DETAILS,
    carrierId: userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
    shipmentId,
  });
};

export const callusClick = () => {
  const callNumber = CALL_US_NUMBER.OTM;
  CallNumber.callNumber(callNumber, true)
    .then((res) => res.data[0])
    .catch((err) => {console.error("Error",err)});
};

export const getUpdatedShipment = (props: any, loadDetails: any) => {
  const shipmentId = (loadDetails && loadDetails.shipmentId) || "";
  const getShipmentmodel: GetShipment = new GetShipment();
  getShipmentmodel.shipmentIds = shipmentId;
  props.buyLoadShipmentRequest({
    query: getShipmentmodel.getRequestShipmentPayload(),
    shipmentId,
    module: getValueFromHistoryState("module", props && props.history),
    isPullToRefresh: true,
  });
  props.clearUpdateStopInfo();
};

const getTime = (time: string, timeZone: string): string => {
  return time ? dayjs.tz(time.slice(0, 16).replace("T"," "), timeZone).format() : time;
};
let updateStopPayloadTemp: any;
export const updateShipmentStopInformation = (
  stopInfo: StopInformation,
  props: any,
  expandedStop: number,
  isLoading?:any,
  trailerWarning?:boolean,
  lateReason?:string| null
) => {
  stopInfo.shipmentId = props.shipmentId;
  stopInfo.sourceSystem = props.loadDetails.sourceTMS;
  const _model: UpdateStopModel = new UpdateStopModel();
  const { userDetails = {} } = props;
  const callBack = async (shipment: any) => {
    isLoading && isLoading(false)
    // Stop the GPS tracking based on geo Tracking Status received by API response
    if (isPlatform("capacitor")) {
      // retived shipmentID from local storage
      const _shipment = IONICWrapper.details.vault && (await IONICWrapper.details.vault.getValue(DB_GPS_ACTIVATED_SHIPMENT));
      const gpsActivatedShipmentID =
        _shipment && JSON.parse(_shipment).shipmentID;
      if (
        !shipment.geoTrackingStatus &&
        gpsActivatedShipmentID &&
        gpsActivatedShipmentID === shipment.shipmentId
      ) {
        GPSWrapper.details.stopGPS();
      }
    }
    
    props.refreshShipmentsLoads(shipment);
  };
  const currentOpenStopSNo = expandedStop + 1;
  if (currentOpenStopSNo === stopInfo.sequenceNo) {
    props.updateStopInformationResponse({
      shipmentId: stopInfo.shipmentId,
      sequenceNo: stopInfo.sequenceNo,
    });
  } else {
    props.clearUpdateStopInformationResponse();
  }
  let stopTrailerActivity:any = stopInfo.stopTrailerActivity;
  stopTrailerActivity = stopTrailerActivity && stopTrailerActivity.map((obj:any)=>removePropertyFromObject(obj,"chassisNumber"));
  let updateStopPayload: StopInformation = {
    sourceSystem: stopInfo.sourceSystem,
    carrierPro: stopInfo.carrierPro,
    carrierScac: stopInfo.carrierScac,
    shipmentId: stopInfo.shipmentId,
    stopId: stopInfo.stopId,
    sequenceNo: stopInfo.sequenceNo,
    stopNumber: stopInfo.stopNumber,
    locationId: stopInfo.locationId,
    carrierId: userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
    userId: userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn,
    city: stopInfo.city,
    state: stopInfo.state,
    country: stopInfo.country,
    latitude: stopInfo.latitude,
    longitude: stopInfo.longitude,
    timeZone: stopInfo.timeZone,
    positionDateTime: stopInfo.positionDateTime,
    actualArrivalDateTime: getTime(
      stopInfo.actualArrivalDateTime,
      stopInfo.timeZone
    ),
    actualETADateTime: getTime(stopInfo.actualETADateTime, stopInfo.timeZone),
    actualDepartureDateTime: getTime(
      stopInfo.actualDepartureDateTime,
      stopInfo.timeZone
    ),
    stopTrailerActivity: stopTrailerActivity,
    gpsTrackingStatus: stopInfo.gpsTrackingStatus,
    lateArrivalReason:lateReason
  }
  if (!props?.isManagedEquipment) {
    if (props.optionSelected === 'yes') {
      updateStopPayload = { ...updateStopPayload, schneiderEquipment: true }
    }
    else if (props.optionSelected === 'no') {
      updateStopPayload = { ...updateStopPayload, schneiderEquipment: false }

    }
  }
  if (trailerWarning){
    updateStopPayload = {
      ...updateStopPayloadTemp,
      userConcentForTrailerWarning: trailerWarning,
    };
  } else {
    updateStopPayloadTemp = {...updateStopPayload};
  }
  props.updateStopInformation(
    _model.updateStop({...updateStopPayload}),
    callBack
  );
};

export const checkDriverUnassignStatus = (
  loadDetails: any,
  userDetails: IUserDetails
) => {
  return (
    (loadDetails &&
      loadDetails.assignmentTransaction &&
      loadDetails.assignmentTransaction[0] && userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member) &&
    !!(
      loadDetails.assignmentTransaction[0].driverId === userDetails.memberDetailsResponse.member.upn
    ) &&
    !!(
      loadDetails.assignmentTransaction[0].transactionType === "Unassign Driver"
    )
  );
};
export const notValidTrailer = (stopDetails: any[]): boolean => !!(
  stopDetails?.find(
    (stop: any) => (
      stop?.stopActivity?.find(
        (activity: any) => !(activity?.equipmentId)
      )
    )
  )
);

export const updateGpsButtonVisibility = (
  shipmentInvolvedParties: ISHIPMENT_INVLOVED_PARTY[],
  member: IMember,
  geoTrackingStatus: boolean,
  buttonType: EGPSTrackingStatus,
  executionStatus: EXECUTIONSTATUS
) => {
  if (executionStatus === EXECUTIONSTATUS.DELIVERED || executionStatus === EXECUTIONSTATUS.COMPLETED) return false;
  const primaryDriver: ISHIPMENT_INVLOVED_PARTY =
    shipmentInvolvedParties?.find(
      (item: ISHIPMENT_INVLOVED_PARTY) => item.partyType === "PRIMARY DRIVER"
    ) || ({} as ISHIPMENT_INVLOVED_PARTY);
  if (
    primaryDriver?.partyEmail === member?.upn ||
    primaryDriver?.partyPhone === member?.mobileNumber
  ) {
    if (buttonType === EGPSTrackingStatus.GPS_TRACKING_STARTED && !geoTrackingStatus) {
      return true;
    }
    if (buttonType === EGPSTrackingStatus.GPS_TRACKING_STOPPED && geoTrackingStatus) {
      return true;
    }
  }
  return false;
};